import { createTheme } from '@mui/material/styles';

// A custom theme for this app
let theme = createTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#373A3C',
    },
    secondary: {
      main: '#1D639F',
      light: '#C2DAFF'
    },
    background: {
      default: '#F2F4F8',
    },
    text: {
      primary: '#7B8491',
      secondary: '#218FE6',
    },
    button: {
      main: '#F4F4F8',
      dark: '#7B849126'
    },
    info: {
      main: '#C6CCD6',
      light: '#DFFAF9'
    },
    error: {
      main: '#C72828',
    },
    action: {
      selected: '#FF0000',
      active: '#E6E8EE',
      disabled: '#7B8491'
    },
    success: {
      main: '#53B3FF',
      light: '#66AA66',
      dark: '#DFFADF'
    },
    warning: {
      main: '#EDB314'
    },
    shadow: {
      main: '#0000000F',
      light: '#F5F7FA',
      dark: '#CCCCCC'
    },
    grey: {
      200: '#F9F9FC',
      300: '#EFF1F5',
      400: '#E7EAEF',
      500: '#DDDDDD',
      600: '#AAAAAA',
      700: '#666666',
      800: '#333333',
      A200: '#E5E5E5'
    }
  },
  shape: {
    borderRadius: 5,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "&::-webkit-scrollbar": {
          width: 3,
        },
        "&::-webkit-scrollbar-track": {
          marginTop: '28px',
          backgroundColor: 'transparent'
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: 'gray',
          borderRadius: '2px',
        },
       
      }
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        ".MuiTabs-flexContainer": {
          minHeight: 76,
        },
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontSize: '21px',
        "&:hover": {
          color: '#1D639F',
          fontWeight: 'bold'          
        },
        "&.Mui-selected": {
          color: '#1D639F',
          fontWeight: 'bold',
        }
      }
    },
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        '&.MuiListItem-root': {
          marginBottom: 30,
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        color: '#7B8491',
        "&.Mui-selected": {
          color: '#1D639F',
          fontWeight: 'bold',
          backgroundColor: 'transparent',
          borderRightColor: '#1D639F',
          borderRightStyle: 'solid',
          borderRightWidth: 3
        },
      }
    },
  },
  MuiListItemText: {
    styleOverrides: {
      root: {
        fontSize: 12,
        "&.Mui-selected": {
          color: '#1D639F',
        }
      }
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        "&.Mui-selected": {
          color: '#1D639F',
        },
      }
    },
  },
}
});


theme = createTheme(theme, {
  typography: {
    h2: {
      fontSize: '1.25rem',
      [theme.breakpoints.down("xl")]: {
        fontSize: '1.15rem',
      },
      [theme.breakpoints.up("xl")]: {
        fontSize: '1.25rem',
      },
    },
    h5: {
      fontSize: '1rem',
      [theme.breakpoints.down("lg")]: {
        fontSize: '0.9rem',
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: '1rem',
      },
    },
  },
});

export default theme;
